
import { Component, Prop, Vue } from "vue-property-decorator";
import { HandicapEquipment, Escort } from "@/api";

@Component({
  name: "EscortOptions",
})
export default class EscortOptions extends Vue {
  @Prop({ default: false }) darkMode!: boolean;
  @Prop({ required: true }) escortLuggage!: boolean;
  @Prop({ required: true }) escortDog!: boolean;

  @Prop({
    type: Array,
    required: true,
  })
  escortOptions!: Array<{
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
    quantity: number;
  }>;

  @Prop({
    type: Array,
    required: true,
  })
  selectedEscortOptions!: Array<{
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
  }>;

  @Prop({ required: true }) toggleEscortDog!: () => void;
  @Prop({ required: true }) toggleEscortLuggage!: () => void;
  @Prop({ required: true }) setEscortOption!: (opt: {
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
  }) => void;
  @Prop({ required: true }) removeEscortOption!: (opt: {
    key: string;
    handicapEquipment: HandicapEquipment | null;
    escort: Escort | null;
  }) => void;

  get safeFilters() {
    return this.filters || {}; // Fallback to an empty object if filters is null
  }

  showAll = false;

  // Computed property to control which options to show
  get displayedOptions() {
    return this.showAll ? this.escortOptions : this.escortOptions.slice(0, 3);
  }
}
